<template>
  <div>
    <el-row type="flex" justify="center" v-loading="loading">
      <el-col
        :span="20"
        :offset="2"
        :xs="24"
        :sm="24"
        :md="24"
        :lg="18"
        :xl="14"
      >
        <el-row :gutter="20">
          <el-row :gutter="20" class="pt40 pb30"  v-if="Object.prototype.hasOwnProperty.call(discountData, 'status')">
            <el-col :span="20" v-if="discountData.status === 'active'">
              <el-steps
                :active="2"
                finish-status="success"
                :space="500"
                align-center
                style="justify-content: center"
              >
                <el-step
                  :title="discountData ? discountData.start_date : ''"
                ></el-step>
                <el-step
                  :title="discountData ? discountData.end_date : ''"
                ></el-step>
              </el-steps>
            </el-col>
            <el-col :span="20" v-if="discountData.status === 'expired'">
              <el-steps
                :active="2"
                finish-status="wait"
                :space="500"
                align-center
                style="justify-content: center"
              >
                <el-step
                  :title="discountData ? discountData.start_date : ''"
                ></el-step>
                <el-step
                  :title="discountData ? discountData.end_date : ''"
                ></el-step>
              </el-steps>
            </el-col>
          </el-row>
          <el-col :span="20">
            <div class="panelClass">
              <div>
                <div class="panel-item">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <header>Үндсэн мэдээлэл</header>
                    </el-col>
                    <el-col
                      :span="8"
                      class="text-right"
                      v-if="
                        Object.prototype.hasOwnProperty.call(
                          discountData,
                          'status'
                        )
                      "
                    >
                      <el-tag
                        size="medium"
                        v-if="discountData.status === 'active'"
                        type="success"
                        effect="dark"
                        >Active</el-tag
                      >
                      <el-tag
                        size="medium"
                        v-else-if="discountData.status === 'expired'"
                        type="info"
                        effect="dark"
                        >Expired</el-tag
                      >
                      <el-tag
                        size="medium"
                        v-else
                        type="warning"
                        effect="dark"
                        >{{ discountData.status }}</el-tag
                      >
                    </el-col>
                    <el-col :span="4">
                      <el-select
                        v-model="setLanguage"
                        placeholder="Mongolia"
                        size="mini"
                      >
                        <el-option
                          v-for="item in Language"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>
                <div class="panel-item border-top">
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <span><strong>Урамшуулалын хэлбэр:</strong></span>
                    </el-col>
                    <el-col
                      :span="12"
                      v-if="
                        discountTypes.find(
                          (item) => item.value === discountData.type
                        )
                      "
                    >
                      <span>{{
                        discountTypes[
                          discountTypes.findIndex(
                            (item) => item.value === discountData.type
                          )
                        ].label
                      }}</span>
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="discountData.discount_code"
                  >
                    <el-col :span="8">
                      <span><strong>Купон код:</strong></span>
                    </el-col>
                    <el-col :span="12">
                      <el-tag type="primary" effect="plain">{{
                        discountData.discount_code
                      }}</el-tag>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" class="mt20">
                    <el-col :span="8">
                      <span><strong>Цацах суваг:</strong></span>
                    </el-col>
                    <el-col :span="12">
                      <span>{{ discountData.channel }}</span>
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="discountData.usage_limit !== null"
                  >
                    <el-col :span="8">
                      <el-tooltip placement="top" effect="dark">
                        <div slot="content">
                          Тухайн урамшуулалыг нийт хэдэн удаа ашиглах хязгаар.
                        </div>
                        <span><strong>Хэрэглээний хязгаар:</strong></span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="12">
                      <span>{{ discountData.usage_limit }} удаа</span>
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="discountData.min_item_count !== null"
                  >
                    <el-col :span="8">
                      <span
                        ><strong
                          >Сагсан дахь бүтээгдэхүүний доод хязгаар:</strong
                        ></span
                      >
                    </el-col>
                    <el-col :span="12">
                      <span
                        ><i class="el-icon-shopping-cart-2" /> -
                        {{ discountData.min_item_count }} ш</span
                      >
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="discountData.max_item_count !== null"
                  >
                    <el-col :span="8">
                      <span
                        ><strong
                          >Сагсан дахь бүтээгдэхүүний дээд хязгаар:</strong
                        ></span
                      >
                    </el-col>
                    <el-col :span="12">
                      <span
                        ><i class="el-icon-shopping-cart-full" /> -
                        {{ discountData.max_item_count }} ш</span
                      >
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="discountData.one_user_limit !== null"
                  >
                    <el-col :span="8">
                      <span
                        ><strong
                          >Нэг хэрэглэгч хэдэн удаа хэрэглэх:</strong
                        ></span
                      >
                    </el-col>
                    <el-col :span="12">
                      <span
                        ><i class="el-icon-user" /> -
                        {{ discountData.one_user_limit === 0 ? 'Хязгааргүй' : discountData.one_user_limit + ' удаа' }}</span
                      >
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="discountData.start_date !== null"
                  >
                    <el-col :span="8">
                      <span
                        ><strong
                          >Эхлэх хугацаа:</strong
                        ></span
                      >
                    </el-col>
                    <el-col :span="12">
                      <span
                        ><i class="el-icon-time" /> -
                        {{ discountData.start_date}}</span
                      >
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="discountData.end_date !== null"
                  >
                    <el-col :span="8">
                      <span
                        ><strong
                          >Дуусах хугацаа:</strong
                        ></span
                      >
                    </el-col>
                    <el-col :span="12">
                      <span
                        ><i class="el-icon-time" /> -
                        {{ discountData.end_date}}</span
                      >
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="setLanguage === 'Mongolia'"
                  >
                    <el-col :span="8">
                      <span><strong>Монгол нэр:</strong></span>
                    </el-col>
                    <el-col :span="12">
                      <span>{{ discountData.title_mon }}</span>
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="setLanguage === 'English'"
                  >
                    <el-col :span="8">
                      <span><strong>Англи нэр:</strong></span>
                    </el-col>
                    <el-col :span="12">
                      <span>{{ discountData.title_eng }}</span>
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="setLanguage === 'Mongolia'"
                  >
                    <el-col :span="8">
                      <span><strong>Монгол тайлбар:</strong></span>
                    </el-col>
                    <el-col :span="12">
                      <span>{{ discountData.desc_mon }}</span>
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="setLanguage === 'English'"
                  >
                    <el-col :span="8">
                      <span><strong>Англи тайлбар:</strong></span>
                    </el-col>
                    <el-col :span="12">
                      <span>{{ discountData.desc_eng }}</span>
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="discountData.all_users !== null"
                  >
                    <el-col :span="8">
                      <span
                        ><strong
                          >Бүх хэрэглэгч сонгосон эсэх:</strong
                        ></span
                      >
                    </el-col>
                    <el-col :span="12">
                      <span
                        >
                        {{ discountData.all_users === 1 ? 'Тийм' : 'Үгүй' }}</span
                      >
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                  >
                    <el-col :span="8">
                      <span
                        ><strong
                          >Захиалгын төрөл</strong
                        ></span
                      >
                    </el-col>
                    <el-col :span="12">
                      <span v-if="discountData.order_type === null"
                        ><b>Хүргэлтээр</b> болон <b>Очиж авах</b></span
                      >
                      <span v-else
                        >
                        {{ discountData.order_type === 'pickup' ? 'Очиж авах' : 'Хүргэлтээр' }}</span
                      >
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div
              class="panelClass"
              v-if="discountData.toktok_partners !== null || discountData.toktok_products !== null || discountData.toktok_services !== null"
            >
              <div class="panel-item">
                <div class="panel-item">
                  <el-tooltip placement="top" effect="dark">
                    <div slot="content">
                      Хэрэглэгч энэхүү нөхцлийг хангаж байж урамшуулалд
                      хамрагдах боломжтой болно.<br />Жишээ нь: Тухайн бараанаас
                      тэдийг авбал гэх мэт ...
                    </div>
                    <header>Нөхцөл</header>
                  </el-tooltip>
                </div>
                <div class="panel-item border-top">
                  <div
                    v-if="
                      Object.prototype.hasOwnProperty.call(
                        discountData,
                        'toktok_partners'
                      ) &&
                      discountData.toktok_partners !== null
                    "
                  >
                    <el-row class="mt20">
                      <span
                        ><strong
                          >Дараахь нийлүүлэгчээс хэдэн ширхэгийг авбал</strong
                        ></span
                      >
                    </el-row>
                    <div
                      class="panelClass mt20"
                      v-for="(supplier, index) in discountData.toktok_partners"
                      :key="index"
                    >
                      <div class="panel-item">
                        <el-row :gutter="20">
                          <el-col :span="12">
                            {{ supplier.outlet_name }}
                          </el-col>
                          <el-col :span="12">
                            <span>{{ supplier.min_count }} - {{supplier.max_count}}ш</span>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      Object.prototype.hasOwnProperty.call(
                        discountData,
                        'toktok_services'
                      ) &&
                      discountData.toktok_services !== null
                    "
                  >
                    <el-row class="mt20">
                      <span
                        ><strong
                          >Дараахь үйлчилгээний төрөлөөс хэдэн ширхэгийг авбал</strong
                        ></span
                      >
                    </el-row>
                    <div
                      class="panelClass mt20"
                      v-for="(service, index) in discountData.toktok_services"
                      :key="index"
                    >
                      <div class="panel-item">
                          <el-row :gutter="20" type="flex" align="middle">
                            <el-col
                              :span="6"
                              :xl="4"
                              :lg="4"
                              :md="6"
                              :sm="6"
                              :xs="6"
                            >
                              <div class="image-holder">
                                <img :src="service.image" alt="" />
                              </div>
                            </el-col>
                            <el-col :span="6">
                              <div class="text-color-secondary">
                                {{ service.name_mon }}
                              </div>
                            </el-col>
                            <el-col :span="4" :offset="8">
                              <span>{{ service.min_count }} - {{service.max_count}}ш</span>
                            </el-col>
                          </el-row>
                        </div>
                    </div>
                  </div>
                  <div
                    v-if="Object.prototype.hasOwnProperty.call(discountData, 'toktok_products') && discountData.toktok_products !== null"
                  >
                    <el-row>
                      <el-col class="mt10">
                        <span
                          ><strong
                            >Дараахь бараануудаас хэдэн ширхэгийг авбал</strong
                          ></span
                        >
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" class="mt20">
                      <div
                        class="panelClass"
                        v-for="(product, index) in discountData.toktok_products"
                        :key="index"
                      >
                        <div class="panel-item">
                          <el-row :gutter="5" type="flex" align="middle">
                            <el-col
                              :span="4"
                              :xl="4"
                              :lg="4"
                              :md="6"
                              :sm="6"
                              :xs="6"
                            >
                              <div class="image-holder">
                                <img :src="product.img_url" alt="" />
                              </div>
                            </el-col>
                            <el-col :span="4">
                              <div class="text-color-secondary">
                                {{ product.name_mon }}
                              </div>
                            </el-col>
                            <el-col :span="4" :offset="10">
                              <span>{{ product.min_count }} - {{product.max_count}}ш</span>
                            </el-col>
                          </el-row>
                        </div>
                      </div>
                    </el-row>
                  </div>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="discountData.min_pay_total !== null"
                  >
                    <el-col :span="8">
                      <span
                        ><strong
                          >Худалдан авалтын дүнгийн хязгаар:</strong
                        ></span
                      >
                    </el-col>
                    <el-col :span="6">
                      <span>min - {{ discountData.min_pay_total }}₮</span>
                    </el-col>
                    <el-col :span="6">
                      <span>max - {{ discountData.max_pay_total }}₮</span>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div
              class="panelClass"
              v-if="
                Object.prototype.hasOwnProperty.call(discountData, 'discount')
              "
            >
              <div class="panel-item">
                <div class="panel-item">
                  <el-tooltip placement="top" effect="dark">
                    <div slot="content">
                      Дээрхи нөхцөлийг хангасан хэрэглэгчид ямар төрлөөр
                      урамшуулахыг харуулж байна.<br />Жишээ нь: Бүтээгдэхүүнээр
                      урамшуулах /Гар утас 5 ширхэгийг бэлэглэх гэх мэт .../
                    </div>
                    <header>Урамшуулал</header>
                  </el-tooltip>
                </div>
                <div class="panel-item border-top">
                  <el-row :gutter="20" class="mt20">
                    <el-col :span="8">
                      <span><strong>Урамшуулалын төрөл:</strong></span>
                    </el-col>
                    <el-col
                      :span="12"
                      v-if="
                        discountSubTypes.find(
                          (item) => item.value === discountData.discount_type
                        )
                      "
                    >
                      <span
                        ><i
                          v-if="discountData.discount_type === 'FREE_DELIVERY'"
                          class="el-icon-bicycle"
                        ></i>
                        {{
                          discountSubTypes[
                            discountSubTypes.findIndex(
                              (item) =>
                                item.value === discountData.discount_type
                            )
                          ].label
                        }}</span
                      >
                    </el-col>
                  </el-row>
                  <div
                    v-if="
                      discountData.discount !== null &&
                      discountData.discount.free_products
                    "
                  >
                    <el-row :gutter="20">
                      <el-col :span="8" class="mt20">
                        <span><strong>Дараахь бүтээгдэхүүнээс</strong></span>
                      </el-col>
                    </el-row>
                    <!-- <div class="mt20 panel" v-for="(product, index) in discountData.discount.free_products" :key="index">
                          <div class="panel-item">
                          <el-row :gutter="20">
                            <el-col :span="16">
                              <el-tag>
                                Item
                              </el-tag>
                            </el-col>
                            <el-col :span="6" :offset="2">
                              <span>{{product.count}}ш</span>
                            </el-col>
                          </el-row>
                          </div>
                        </div> -->
                    <div
                      class="panelClass mt20"
                      v-for="(product, index) in discountData.discount
                        .free_products"
                      :key="index"
                    >
                      <div class="panel-item">
                        <el-row :gutter="5" type="flex" align="middle">
                          <el-col
                            :span="4"
                            :xl="4"
                            :lg="4"
                            :md="6"
                            :sm="6"
                            :xs="6"
                          >
                            <div class="image-holder">
                              <img :src="product.variant_image" alt="" />
                            </div>
                          </el-col>
                          <el-col :span="4">
                            <div class="text-color-secondary">
                              {{ product.product_mon_name }}
                            </div>
                            <div>{{ product.variant_name }}</div>
                          </el-col>
                          <el-col :span="4" :offset="10">
                            <span>{{ product.count }}ш</span>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="
                      discountData.discount !== null &&
                      discountData.discount.saled_percentage
                    "
                  >
                    <el-col :span="8">
                      <span><strong>Хямдрах хувь:</strong></span>
                    </el-col>
                    <el-col
                      :span="12"
                      v-if="
                        discountData.discount !== null &&
                        Object.prototype.hasOwnProperty.call(
                          discountData.discount,
                          'saled_percentage'
                        )
                      "
                    >
                      <span>{{ discountData.discount.saled_percentage }}%</span>
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="
                      discountData.discount !== null &&
                      discountData.discount.saled_price
                    "
                  >
                    <el-col :span="8">
                      <span><strong>Хямдрах дүн:</strong></span>
                    </el-col>
                    <el-col
                      :span="12"
                      v-if="
                        discountData.discount !== null &&
                        Object.prototype.hasOwnProperty.call(
                          discountData.discount,
                          'saled_price'
                        )
                      "
                    >
                      <span>{{ discountData.discount.saled_price }}₮</span>
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    class="mt20"
                    v-if="discountData.user_limit !== null && discountData.user_limit.is_user_limit === 1 && Object.prototype.hasOwnProperty.call(discountData.user_limit, 'users')"
                  >
                    <el-col :span="8">
                      <span
                        ><strong
                          >Хэрэглэгчийн утас:</strong
                        ></span
                      >
                    </el-col>
                    <el-col :span="12"
                    >
                      <span v-if="phoneNumber.length > 0 && phoneNumber !== null">{{phoneNumber.length}} ш дугаар байна</span>
                      <el-card style="max-height:200px; overflow:auto">
                        <span v-for="x in phoneNumber" :key="x">{{ x }} </span>
                      </el-card>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div
              class="panelClass"
              v-if="
                Object.prototype.hasOwnProperty.call(discountData, 'history') && discountData.history.length > 0
              "
            >
              <div class="panel-item">
                <div class="panel-item">
                  <header>Үүсгэсэн мэдээлэл</header>
                </div>
                <div class="panel-item border-top">
                  <el-row :gutter="20" class="mt20">
                    <el-col :span="8">
                      <span><strong>Үүсгэсэн :</strong></span>
                    </el-col>
                    <el-col :span="12">
                      <span>{{discountData.history[0].user_name}}</span
                      >
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" class="mt20">
                    <el-col :span="8">
                      <span><strong>Хугацаа :</strong></span>
                    </el-col>
                    <el-col :span="12">
                      <span>{{discountData.history[0].created_at}}</span
                      >
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="text-left">
              <el-button
                v-if="is_show === true"
                type="danger"
                @click="confirmDiscountDialog = true"
              >Устгах
              </el-button>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="text-right">
              <el-button type="default" @click="goBack">Буцах </el-button>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      title="Хямдрал устгах"
      :visible.sync="confirmDiscountDialog"
      width="50%"
    >
      <div>
        <strong>{{ discountData.title_mon }}</strong> хямдралыг устгахдаа
        итгэлтэй байна уу?
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmDiscountDialog = false" class="mr10"
          >Болих</el-button
        >
        <el-button
          v-if="is_show === true"
          :disabled="isDisabled"
          type="danger"
          @click="deleteDiscountApp(discountData.id)"
        >
          Устгах
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import services from '../../helpers/services'
import { getGroups } from '@/utils/auth.js'
export default {
  name: 'detailDiscountFood',
  data () {
    return {
      isDisabled: false,
      confirmDiscountDialog: false,
      treeDefaultProps: {
        children: 'childrens',
        label: 'name_mon'
      },
      loading: false,
      setLanguage: 'Mongolia',
      Language: [
        {
          value: 'English',
          label: 'Англи'
        },
        {
          value: 'Mongolia',
          label: 'Монгол'
        }
      ],
      discountSubTypes: [
        {
          value: 'PERCENTAGE',
          label: 'Хувиар %'
        },
        {
          value: 'FIXED_AMOUNT',
          label: 'Үнийн дүнгээр'
        },
        {
          value: 'FREE_DELIVERY',
          label: 'Үнэгүй хүргэлт'
        },
        {
          value: 'PRODUCT',
          label: 'Бүтээгдэхүүн'
        }
      ],
      discountItemTypes: [
        {
          value: 'all_product',
          label: 'Бүх бүтээгдэхүүн'
        },
        {
          value: 'products',
          label: 'Сонгосон бүтээгдэхүүн'
        },
        {
          value: 'categories',
          label: 'Сонгосон ангилалын бүх бүтээгдэхүүн'
        },
        {
          value: 'suppliers',
          label: 'Сонгосон нийлүүлэгчийн бүх бүтээгдэхүүн'
        }
      ],
      discountTypes: [
        {
          value: 'DISCOUNT_CODE',
          label: 'Купон код'
        },
        {
          value: 'AUTO',
          label: 'Автоматаар бодогдох'
        }
      ],
      discountData: null,
      phoneNumber: null,
      is_show: true,
      groups: []
    }
  },

  created () {
    if (this.$route.params.id) {
      this.getOneDiscountApp(this.$route.params.id)
    }
  },

  methods: {
    deleteDiscountApp (id) {
      this.loading = true
      this.isDisabled = true
      services.deleteDiscount(id).then((response) => {
        if (response.status === 'success') {
          this.$notify({
            title: 'Амжилттай',
            message: `${id} дугаартай хямдрал устлаа`,
            type: 'success'
          })
          this.loading = false
          this.isDisabled = false
          this.goBack()
        } else if (response.status === 'error') {
          this.$notify({
            title: 'Алдаа',
            message: `${id} дугаартай хямдралыг устгахад алдаа гарлаа`,
            type: 'error'
          })
          this.loading = false
          this.isDisabled = false
        }
      })
    },

    filterNode (value, data) {
      if (!value) return true
      return this.discountData.categories.name_mon.indexOf(value) !== -1
    },

    goBack () {
      this.$router.go(-1)
    },
    async getOneDiscountApp (id) {
      this.group = await getGroups()
      if (this.group.includes('view')) this.is_show = false
      this.loading = true
      await services.getOneDiscount(id).then(async (response) => {
        if (response.status === 'success') {
          if (response.data.toktok_partners !== null) {
            if (response.data.toktok_partners.length === 0) {
              response.data.toktok_partners = null
            }
          }
          if (response.data.toktok_products !== null) {
            if (response.data.toktok_products.length === 0) {
              response.data.toktok_products = null
            }
          }
          if (response.data.toktok_services !== null) {
            if (response.data.toktok_services.length === 0) {
              response.data.toktok_services = null
            }
          }
          if (response.data.user_limit !== null) {
            this.phoneNumber = response.data.user_limit.users
          }
          if (response.data.end_date === null) {
            response.data.end_date = 'Хязгааргүй'
          }
          this.discountData = await response.data
          this.loading = false
        }
      })
    }
  }
}
</script>
